<template>
    <PageFull header="Адм. операции" type="white" :fullwidth="true">
        <template v-slot:body>
            <div v-if="!loading && operations" class="w-full flex m-0 p-0">
                <OperationsList 
                    :operations="operations" 
                    :loading="loading"
                    :filters="lazyParams.filters"
                    :totalRecords="totalRecords" 
                    :skip="skip"
                    :defaultParams="lazyParams"
                    @loading="loading = $event"
                    @refresh="LoadOperations"
                    @onPageChange="onPageChange" @onFilter="onFilter" @onPageRowsChange="onPageRowsChange"
                    />
            </div>
            <Skeleton v-else width="100%" height="30px" class="mx-3" />
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import PageFull from '@/components/sides/PageFull.vue'
import OperationsList from '@/components/admin/operation/list.vue'

export default {
    data() {
        return {
            operations: [],
            loading: false,
            totalRecords: 0,
            currencies: [],
            systemWallets: [],
            setAddress: false,
            skip: 0,
            lazyParams: {
                first: 0,
                rows: 50,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            filters: {
                '_id': { value: null, matchMode: 'contains' },
                'user_id': { value: null, matchMode: 'contains' },
                'status': { value: null, matchMode: 'contains' },
                'step': { value: null, matchMode: 'contains' },
                'type': { value: null, matchMode: 'contains' },
                'transfer_id': { value: null, matchMode: 'contains' },
                'external_source': { value: null, matchMode: 'contains' },
                'hash': { value: null, matchMode: 'contains' },
            }
        }
    },
    watch: {
        setAddress: {
            handler(newVal) {
                if(newVal) this.selectedColumns = ['адреса']
                else this.selectedColumns = []
            },
            immediate: true
        },
    },
    components: {
        PageFull,
        OperationsList
    },
    methods: {
        async resetFilter() {
            this.lazyParams.filters = {
                '_id': { value: '', matchMode: 'contains' },
                'user_id': { value: '', matchMode: 'contains' },
                'status': { value: '', matchMode: 'contains' },
                'step': { value: '', matchMode: 'contains' },
                'type': { value: '', matchMode: 'contains' },
                'transfer_id': { value: '', matchMode: 'contains' },
                'external_source': { value: '', matchMode: 'contains' },
                'hash': { value: '', matchMode: 'contains' },
            };
            await this.LoadOperations();
        },
        onPageChange(val) {
            this.lazyParams = val
            this.LoadOperations()
        },
        onPageRowsChange(val) {
            this.lazyParams = val
            this.LoadOperations()
        },
        onFilter(filters) {
            this.lazyParams.filters = filters
            this.LoadOperations()
        },
        async LoadOperations() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
            this.operations = []
            this.totalRecords = 0
            const operations = await this.connect.GetOperations(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res => res)
            if (operations.result && operations.data.length >= 0) {
                this.operations = operations.data
                this.totalRecords = operations.total
            }
            this.loading = false
        },
    },  
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters

        // получить transfer_id
        const transfer_id = (this.$route.query.transfer_id) ? this.$route.query.transfer_id : null
        if(transfer_id) this.filters.transfer_id = {value: transfer_id, matchMode: 'contains'}

        const operation_id = (this.$route.query.operation_id) ? this.$route.query.operation_id : null
        if(operation_id) this.filters._id = {value: operation_id, matchMode: 'contains'}

        this.systemWallets = (this.$store.getters.GetAdminWallets) ? this.$store.getters.GetAdminWallets : []
        
        await this.LoadOperations()
    },
}
</script>